import ViewNewsfeedModalCtrl from '../ViewNewsfeedModalCtrl';
import modalNewsfeedViewUrl from '../modal-newsfeed-view.html';
export default function Comments(
  Users,
  Restangular,
  Authentication,
  NewsfeedCollection,
  TaskCollection,
  RenderContent,
  $uibModal
) {
  'ngInject';

  Restangular.extendModel('comments', (comment) => {
    if (comment.user) {
      Restangular.restangularizeElement(null, comment.user, 'users');
    }

    comment.canEdit = false;

    if (comment.user) {
      comment.canEdit = comment.user.isMe;
    }

    if (comment.content) {
      comment.renderedContent = RenderContent.get(comment.content, true);
    }

    // Liking comments only works on newsfeed (at least for now)

    comment.like = function likeComment() {
      comment.likes++;
      comment.liked = true;

      comment
        .all('likes')
        .post()
        .then(null, (error) => {
          comment.likes--;
          comment.liked = false;
          console.log(error);
        });
    };

    comment.unlike = function unlikeComment() {
      comment.likes--;
      comment.liked = false;

      comment
        .all('likes')
        .remove()
        .then(null, (error) => {
          comment.likes++;
          comment.liked = true;
          console.log(error);
        });
    };

    comment.toggleLike = function toggleLike() {
      if (comment.liked) {
        comment.unlike();
      } else {
        comment.like();
      }
    };

    comment.showLikes = function showLikes() {
      comment
        .all('likes')
        .getList({ 'user-fields': 'id' })
        .then((data) => {
          Restangular.restangularizeCollection(null, data, 'users');

          $uibModal
            .open({
              size: 'sm',
              templateUrl: modalNewsfeedViewUrl,
              controller: ViewNewsfeedModalCtrl,
              controllerAs: 'ctrl',
              resolve: {
                type() {
                  return 'likes';
                },
                users() {
                  return data;
                },
              },
            })
            .result.ignoreCancel();
        });
    };

    return comment;
  });

  Restangular.addRequestInterceptor((element, operation, what) => {
    if (what === 'comments') {
      // Do NOT send a payload for the DELETE, see https://github.com/getsling/sling-server/issues/1369
      if (operation === 'remove') {
        return null;
      }
    }

    return element;
  });

  Restangular.addResponseInterceptor((data, operation, what) => {
    if (what === 'comments' && data.articleId) {
      _handleArticleComment(data, operation);
    }

    if (what === 'comments' && data.taskId) {
      _handleTaskComment(data, operation);
    }

    return data;
  });

  function _handleArticleComment(data, operation) {
    if (operation === 'post') {
      NewsfeedCollection.addComment(data);
    }

    if (operation === 'put') {
      NewsfeedCollection.editComment(data);
    }

    if (operation === 'remove') {
      NewsfeedCollection.deleteComment(data);
    }
  }

  function _handleTaskComment(data, operation) {
    if (operation === 'post' || operation === 'put') {
      TaskCollection.addOrEditComment(data);
    }

    if (operation === 'remove') {
      TaskCollection.deleteComment(data);
    }
  }

  return Restangular.service('comments');
}
